import React from "react";
import { s } from "../styles";

export default function OtherRow() {
  const cell = (
    <div style={s.ocell}>
      <div style={s.och}>
        <span style={{ width: 34 }}>Box &ndash; Case</span>
        <span style={s.ochA}>Amount &ndash; Montant</span>
      </div>
      <div style={s.ocf}>
        <span style={s.obc} />
        <span style={s.oam} />
      </div>
    </div>
  );
  return (
    <div style={s.orow}>
      {cell}
      {cell}
      {cell}
    </div>
  );
}